import { createHook, createSelector, type BoundActions } from 'react-sweet-state';

import type { AccessTokenModalState, UIState } from '../../../../common/types';
import type { Actions } from '../../actions';
import { Store } from '../../main';

export type UseAccessTokenModalState = () => [
	AccessTokenModalState,
	Partial<BoundActions<UIState, Actions>>,
];

export const accessTokenModalSelector = createSelector(
	(state: UIState): AccessTokenModalState => state.accessTokenModal,
	(newState: AccessTokenModalState) => newState,
);

export const useAccessTokenModalState = createHook(Store, {
	selector: accessTokenModalSelector,
});
